import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './BecomePartner.css';
import { FaEnvelope, FaUserPlus, FaSignInAlt, FaFileDownload, FaBed, FaSearch, FaQrcode, FaHandshake, FaMoneyBillWave } from 'react-icons/fa';

const BecomePartner = () => {
    const { t } = useTranslation();

    const steps = [
        {
            icon: <FaEnvelope />,
            title: t('partner_step1_title', '1. Contact Us'),
            desc: t('partner_step1_desc', 'Send an email to support@cityhuntersbg.com that you want to become a partner.'),
            hasImage: false
        },
        {
            icon: <FaUserPlus />,
            title: t('partner_step2_title', '2. Profile Creation'),
            desc: t('partner_step2_desc', 'We create your profile with a default password and a unique discount coupon.'),
            hasImage: false
        },
        {
            icon: <FaSignInAlt />,
            title: t('partner_step3_title', '3. Login & Secure'),
            desc: t('partner_step3_desc', 'Login to the partner portal with the default credentials and update your password.'),
            hasImage: true,
            imgAlt: 'Screenshot: Step 3',
            imgSrc: '/assets/partner_portal.png',
            link: '/partner',
            linkLabel: t('partner_login', 'Partner Login')
        },
        {
            icon: <FaFileDownload />,
            title: t('partner_step4_title', '4. Get Your Vouchers'),
            desc: t('partner_step4_desc', 'In the portal you will see the created voucher/s. You can download the voucher in different formats (A4, A5, A6) and print them. If preferred, we can print them and send them to you.'),
            hasImage: true,
            imgAlt: 'Screenshot: Step 4',
            imgSrc: '/assets/partner_portal2.png'
        },
        {
            icon: <FaBed />,
            title: t('partner_step5_title', '5. Display in Rooms'),
            desc: t('partner_step5_desc', 'Place the printed vouchers in your hotel room/s or apartments.'),
            hasImage: true,
            imgAlt: 'Screenshot: Step 5',
            imgSrc: '/assets/table_vaucher.jpg'
        },
        {
            icon: <FaSearch />,
            title: t('partner_step6_title', '6. Guest Discovery'),
            desc: t('partner_step6_desc', 'Your guests look for an interesting way to get to know the city and see the discount voucher in the room.'),
            hasImage: false,
            imgAlt: 'Screenshot: Step 6'
        },
        {
            icon: <FaQrcode />,
            title: t('partner_step7_title', '7. Guest Purchase'),
            desc: t('partner_step7_desc', 'Your guests scan the barcode and purchase the game with an instant discount.'),
            hasImage: false
        },
        {
            icon: <FaHandshake />,
            title: t('partner_step8_title', '8. Win-Win'),
            desc: t('partner_step8_desc', 'Your guests have a fantastic time, and you receive money for the referral!'),
            hasImage: false
        },
        {
            icon: <FaMoneyBillWave />,
            title: t('partner_step9_title', '9. Get Paid'),
            desc: t('partner_step9_desc', 'Login to your partner profile again to see the amount collected. Once you reach 10 euros, you can click on "receive" and we will send the funds to your account.'),
            hasImage: true,
            imgAlt: 'Screenshot: Step 9',
            imgSrc: '/assets/partner_portal3.png'
        }
    ];

    return (
        <div className="become-partner-container">
            {/* Hero Section */}
            <div className="bp-hero">
                <h1>{t('partner_hero_title', 'Partner with City Hunters')}</h1>
                <p>{t('partner_hero_subtitle', 'Earn money while offering your guests an unforgettable city adventure.')}</p>
                <a href="mailto:support@cityhuntersbg.com" className="bp-cta-button">
                    {t('partner_cta', 'Become a Partner Today')}
                </a>
            </div>

            {/* Timeline Section */}
            <div className="bp-timeline">
                {steps.map((step, index) => (
                    <div className={`bp-step ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                        <div className="bp-step-content">
                            <div className="bp-step-icon">{step.icon}</div>
                            <h3>{step.title}</h3>
                            <p>{step.desc}</p>
                            {step.link && (
                                <Link to={step.link} className="bp-step-link">
                                    {step.linkLabel}
                                </Link>
                            )}
                            {step.hasImage && (
                                <div className="bp-image-placeholder">
                                    {step.imgSrc ? (
                                        <img src={step.imgSrc} alt={step.imgAlt} />
                                    ) : (
                                        <div className="placeholder-text">
                                            <i className="fas fa-image"></i>
                                            <p>{step.imgAlt}</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer CTA */}
            <div className="bp-footer-cta">
                <h2>{t('partner_footer_title', 'Ready to get started?')}</h2>
                <p>{t('partner_footer_desc', 'Join us today and bring an exciting experience to your guests.')}</p>
                <a href="mailto:support@cityhuntersbg.com" className="bp-cta-button">
                    {t('partner_cta', 'Become a Partner Today')}
                </a>
            </div>
        </div>
    );
};

export default BecomePartner;
